import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useQuery } from "@tanstack/react-query";
import { fetchPostDetail } from "@/hooks/useSearch";
import type { PostDetailData } from "@/hooks/useSearch";
import { PostDetail } from "@/components/PostDetail";

export function PostDetailPage() {
  const { id } = useParams<{ id: string }>();
  const postId = Number(id);

  const { data: post, isLoading, isError } = useQuery<PostDetailData>({
    queryKey: ["post", postId],
    queryFn: () => fetchPostDetail(postId),
    enabled: !isNaN(postId),
  });

  return (
    <>
      <Helmet>
        <title>{post ? `Post #${post.id} — GIF Search` : "Loading — GIF Search"}</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="min-h-screen bg-surface-0">
        {/* Nav */}
        <div className="sticky top-0 z-30 bg-surface-0/95 backdrop-blur border-b border-surface-2 px-4 py-3">
          <div className="max-w-6xl mx-auto flex items-center gap-3">
            <Link to={-1 as unknown as string} className="text-sm text-zinc-400 hover:text-white transition-colors min-h-[40px] inline-flex items-center">
              ← Back
            </Link>
            {post && (
              <span className="text-sm text-zinc-600 font-mono">post #{post.id}</span>
            )}
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-6">
          {isLoading && (
            <div className="space-y-4 animate-pulse">
              <div className="bg-surface-2 rounded-xl h-96" />
              <div className="bg-surface-2 rounded-xl h-48" />
            </div>
          )}

          {isError && (
            <div className="text-center py-20">
              <p className="text-red-400">Post not found or unavailable.</p>
              <Link to="/search" className="text-accent-light hover:underline text-sm mt-2 inline-block">
                Back to search
              </Link>
            </div>
          )}

          {post && <PostDetail post={post} />}
        </div>
      </div>
    </>
  );
}
